import React from 'react';

import ButtonGroupBase from './ButtonGroupBase';

const ButtonGroup = ({ children }) => {
  return <ButtonGroupBase>{children}</ButtonGroupBase>;
};

export default ButtonGroup;
